<template>
  <div>
    <div v-if="!isConfirmation">
      <p class="px-4 text-sm mb-2 text-grey-575">About you</p>
      <div class="bg-white py-4 px-4 mb-4 section-grid items-center">
        <div>
          <div class="font-medium mb-1"> {{ $store.getters.getFirstName }} {{ $store.getters.getLastName }} </div>
          <div class="">{{ $store.getters.getEmail }}</div>
        </div>
        <RouterLink v-if="!isPortal" to="/personal-details" class="no-underline text-right text-blue-500">
          Change
        </RouterLink>
      </div>
    </div>
    <p class="px-4 text-sm mb-2 text-grey-575">About your business</p>
    <div class="bg-white py-4 px-4 mb-6 section-grid items-center text-grey-550 text-sm">
      <div>
        <div class="font-medium mb-1 text-blue-700">
          {{
            $store.getters.getBusinessName
              ? $store.getters.getBusinessName
              : `${$store.getters.getFirstName} ${$store.getters.getLastName}`
          }}
        </div>
        <div class="">{{ $store.getters.getIndustryName }}</div>
        <div class="">
          <span> Up to {{ turnover | currency }} turnover</span>
        </div>
        <div class="">
          <div v-if="employeeCount === 1">Just 1 person</div>
          <div v-else>
            <span> {{ `Up to ${employeeCount} employees` }} </span>
          </div>
        </div>
      </div>
      <RouterLink v-if="!isPortal" to="/" class="no-underline text-right text-blue-500">Change</RouterLink>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isConfirmation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPortal () {
      return !!this.$store.state.portal
    },
    turnover: {
      get () {
        return this.$store.getters.getTurnover
      },
    },
    employeeCount: {
      get () {
        return this.$store.getters.getEmployeeCount
      },
    },
  },
}
</script>

<style>
.section-grid {
  display: grid;
  grid-template-columns: 9fr 2fr;
  grid-gap: 10px;
}
</style>
